import {ClientConfiguration} from "./services/configuration/client.config";
import {Login} from "./login/login";

export class BootGlobals {
    public static appRoot: string;
    public static config: ClientConfiguration;
    public static login: Login;
}